module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAMAAAAmuJTXAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABIUExURQAAAP///////////////////////////////////////////////////////////////////////////////////////////+d4eLAAAAAXdFJOUwAQID9AYGSApqvb3+Ll7e/w9fb4+f3+rdIQswAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAF9JREFUKFONzMkOgCAMRdFWwQkUZ/7/T22VGEpdeFdNTl7hV806Yjpl9owxfJHdI+U1MRxfxDD1XtMNHaCiBKDohZIykCQgJ7MJSOSI2gIemg1vFglELgz8riIuwhrhAo67B8z7CcAFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/appointment/jts_icon.png
// module id = 3pQ4
// module chunks = 1